//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prepareBoms', {
//        templateUrl: 'views/components/views/prepareBoms/prepareBoms.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'prepareBomsService', 'rememberService', 'ttGridFactory', function (stateService, utilityService, prepareBomsService, rememberService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                show_only_cad_imported: ''
//            };

//            vm.model = {
//                setting: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_prepareboms.prepareboms_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await prepareBomsService.getPrepareBoms())[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.show_only_cad_imported, true) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 2652,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'show_only_cad_imported':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'show_only_cad_imported':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.show_only_cad_imported) !== true) return;

//                        vm.model.setting.show_only_cad_imported = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.show_only_cad_imported, true) !== true) return;

//                        rememberFunc('show_only_cad_imported');
//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
